import { FaLocationDot, FaPhone } from "react-icons/fa6"
import { IoMail, IoPersonSharp } from "react-icons/io5"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { DecodeHtml } from "../utils/decodeHtml"
import { MyTable } from "../components/campusLife/swimmingPoolHours"


const GymnasiumHours = () => {


    const state = useSelector(state => state.campusLifeTab)
    const gymnasium = state?.data?.properties

    const gymnasiumOperationHoursNotes1 = gymnasium?.gymnasiumOperationHoursNotes1
    const gymnasiumPoolEnquiryContacts = gymnasium?.gymnasiumPoolEnquiryContacts?.items?.map(item => ({ type: item?.content?.properties?.icon, text: DecodeHtml({ html: item?.content?.properties?.label?.markup }) }))


    const [tableData, setTableData] = useState({
        headers: [],
        mobile: [],
        contents: []
    });

    useEffect(() => {
        const headers = [];
        const mobile = [];
        const contents = [];

        gymnasium?.gymnasiumOperationHoursTable1?.items.forEach((item) => {
            // Extract the label for the header
            const headerLabel = item?.content?.properties?.label;
            headers.push(headerLabel);
            mobile.push(headerLabel);

            const rowData = [];
            item?.content?.properties?.content?.items?.forEach((contentItem) => {
                // Extract the content for each cell
                const cellContent = contentItem?.content?.properties?.richText?.markup;
                rowData.push(DecodeHtml({ html: cellContent }));
            });
            contents.push(rowData);
        });

        setTableData({ headers, mobile, contents });
    }, [gymnasium?.gymnasiumOperationHoursTable1]);
    // const contacts = [
    //     {
    //         location: "Putrajaya campus",
    //         info: [
    //             {
    //                 name: "Mrs. Nur Shazura bte Roslan, Manager",
    //                 mobile: "+603-8921 2020 ext 1131 ",
    //                 email: "nurshazura@uniten.edu.my"
    //             },
    //             {
    //                 name: "Mrs. Tan Chin Hung, Senior Lecturer",
    //                 mobile: "+603-8921 2020 ext 7527",
    //                 email: "chtan@uniten.edu.my"
    //             },
    //             {
    //                 name: "Mr. Ikmal Bin Abdul Jaabar, Sports Executive",
    //                 mobile: "+603-8921 2020 ext 1318",
    //                 email: "ikmal@uniten.edu.my"
    //             },
    //         ]

    //     },
    //     {
    //         location: "kshas campus",
    //         info: [
    //             {
    //                 name: "Mr. Norafizi Bin Mohd Nor, Administrative Officer",
    //                 mobile: "+609-455 2020 ext 2155",
    //                 email: "norafizi@uniten.edu.my"
    //             },

    //         ],

    //     },

    // ]
    return (
        <div className="w-full flex flex-col  gap-2 my-5">
            <div className="flex items-center gap-2">
                <h1 className="w-auto   text-slate-900 text-2xl font-bold  uppercase">Gymnasium Operations Hours</h1>
                <span className="text-slate-400  text-sm font-bold  ">{gymnasiumOperationHoursNotes1}</span>
            </div>
            <div className='grid grid-cols-1 '>
                <div className="w-full flex items-center justify-center">
                    <MyTable headers={tableData.headers} mobile={tableData.mobile} contents={tableData.contents} />

                </div></div>
            <div className="flex flex-col gap-8 my-8">
                <h1 className="w-auto   text-slate-900 text-2xl font-bold  uppercase">Contact Us</h1>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                    {
                        gymnasiumPoolEnquiryContacts?.map((contact, index) => {
                            return (
                                <div key={index} className="flex flex-col items-center md:items-start gap-2">
                                    {
                                        contact.type === "Location Icon" &&
                                        <span className="text-xl text-center font-semibold w-full justify-center md:justify-start md:text-left leading-normal flex  items-center ">
                                            <div className="w-8">
                                                <FaLocationDot size={20} />
                                            </div>
                                            {contact.text}</span>
                                    }
                                    <div className='flex flex-col 2xl:w-[60%]'>


                                        <div className="flex flex-col w-full  items-start my-2 gap-4">
                                            {
                                                contact.type === "Person Icon" &&
                                                <span className="text-base font-semibold underline leading-normal flex   items-center ">
                                                    <div className="w-8">
                                                        <IoPersonSharp size={20} />
                                                    </div>
                                                    {contact.text}</span>
                                            }
                                            {
                                                contact.type === "Phone Icon" &&
                                                <span className="text-base font-normal leading-normal flex items-center   ">
                                                    <div className="w-8">
                                                        <FaPhone size={20} />
                                                    </div>
                                                    {contact.text}</span>

                                            }
                                            {
                                                contact.type === "Email Icon" &&
                                                <span className="text-base font-normal leading-normal flex items-center   ">
                                                    <div className="w-8">
                                                        <IoMail size={20} />
                                                    </div>
                                                    {contact.text}</span>
                                            }
                                        </div>


                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
            </div>
        </div>
    )
}

export default GymnasiumHours